import { z } from 'zod';
import { applicantMetadata, guarantors } from '../shared';
import { ApplicationStep } from '../types';
import { baseApplicationStep } from './baseApplication';

export const updateGuarantorDetailsSchema = z
  .object({
    step: z.literal(ApplicationStep.GuarantorDetails),
    enterprise: guarantors,
    applicant: applicantMetadata.pick({ type: true }),
  })
  .and(baseApplicationStep);

export type UpdateGuarantorDetailsSchema = z.infer<typeof updateGuarantorDetailsSchema>;
